import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function CustomDatePicker({label,value, onChange, width, size = "small", format = "DD/MM/YYYY", minDate, maxDate}) {
  return (
    <ArgonBox display="flex" alignItems="center">
      {/* Label */}
      {label && (
        <ArgonTypography variant="body2" color="text" fontWeight="medium">
          {label}
        </ArgonTypography>
      )}

      {/* DatePicker with LocalizationProvider wrapped */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={onChange}
          format={format}
          minDate={minDate}
          maxDate={maxDate}
          slotProps={{
            textField: {
              size,
              sx: {
                ml: label ? 1 : 0,
                width,
                "& .MuiInputBase-input": { py: 0.8, px: 1.5 },
              },
            },
          }}
        />
      </LocalizationProvider>
    </ArgonBox>
  );
}

CustomDatePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.object.isRequired, // dayjs object
  onChange: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(["small", "medium"]),
  format: PropTypes.string,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
};

export default CustomDatePicker;
